//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { ITrackableComponent } from '@utils/withTracking';
import { ButtonAnchor } from '@welcome-page/components/onboarding/buttons/ButtonAnchor';
import { useVibeButtonStyles } from '@welcome-page/hooks/useVibeButtonStyles';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  ITrackableComponent;

// TODO: PD-257587 - remove this component
export const VibeButtonAnchor = (props: Props) => {
  const styles = useVibeButtonStyles();
  return <ButtonAnchor styles={styles} {...props} />;
};
